import { useQuery } from '@tanstack/react-query';

import { callGetUserStats } from '@app/client/resources/yat-pages/page-items';

import { useNFTMainOwnerData } from './useNFTMainOwnerData';

type useUserStatsProps = {
    id?: string;
};

export const useUserStats = ({ id }: useUserStatsProps = {}) => {
    const { owner } = useNFTMainOwnerData(undefined, undefined, !!id);
    const ownerId = id || owner?.id || '';
    const cache = ['ownerStats', ownerId];

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetUserStats({
                ownerId,
                settings: {
                    signal,
                },
            }),
        retry: false,
        enabled: Boolean(ownerId),
        select: (r) => {
            if (r?.ok) {
                return r.value;
            }
        },
    });
};
